/**
 * @author       hugo@zumper.com (Hugo Pineda)
 * @copyright    Copyright (c) 2020, Zumper
 */

import { groupPropertyTypesByTopCategories } from '@zcode-ui/filters'
import { capitalize } from '@zcode/nr-utils'
import type { Filters } from '@zcode/state-type'

export const mapPropertyCategories = (propertyTypes: Filters['propertyTypes']) => {
  const topCategories = groupPropertyTypesByTopCategories(propertyTypes)
  const categories: string[] = []
  for (const catName in topCategories) {
    if (topCategories[catName as keyof typeof topCategories]) {
      categories.push(capitalize(catName))
    }
  }
  return categories
}
